export default "__VITE_ASSET__DuvNyPtL__"